import { tr, trServer, LANG } from "./i18n";
import axios from "axios";

// Same domain-independence rule as api.js — empty/unset variable means
// call the current origin at `/api/public/...`.
const RAW_BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
export const PUBLIC_API_BASE = `${RAW_BACKEND_URL}/api/public`;

// Public API client — NO Authorization header, NO credentials.
export const publicApi = axios.create({
  baseURL: PUBLIC_API_BASE,
});
// public texts come back in the visitor's language (Arabic version when the owner typed one)
publicApi.interceptors.request.use((config) => {
  if ((config.method || "get") === "get") config.params = { ...(config.params || {}), lang: LANG };
  return config;
});

/** Digits only (spaces, dashes, dots, brackets ignored), optional leading +, 7 to 15 digits. */
export function isValidMobile(v) {
  return /^\+?\d{7,15}$/.test(String(v || "").replace(/[\s\-().]/g, ""));
}

/** Value of the hidden honeypot field inside a submitted form. */
export function honeypotOf(e) {
  return e?.target?.elements?.website?.value || "";
}

export function formatPublicError(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return trServer(detail);
  return tr("x.something_went_wrong_please_try_again");
}
